import { Heading } from '@sparemin/blockhead';
import TableCells from 'components/TableCells';
import { SocialSharePodcasts } from 'pages/headliner/state';
import { Column, CellProps } from 'react-table';

const columns: ReadonlyArray<Column<SocialSharePodcasts>> = [
  {
    Header: 'Podcast',
    id: 'podcast',
    Cell: ({ row }: CellProps<SocialSharePodcasts>) => (
      <TableCells.PodcastInfoCell
        url={row.original.thumbnailUrl}
        title={row.original.title}
        episodeCount={row.original.totalEpisodes}
      />
    ),
    disableSortBy: true,
    width: 800,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Views</Heading>} />
    ),
    id: 'views',
    Cell: ({ row }: CellProps<SocialSharePodcasts>) => (
      <TableCells.NumericCell
        value={row.original.statistics.viewCount}
        isValueStale={row.original.statistics.isViewCountStale}
      />
    ),
    disableSortBy: true,
    width: 100,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Likes</Heading>} />
    ),
    id: 'likes',
    Cell: ({ row }: CellProps<SocialSharePodcasts>) => (
      <TableCells.NumericCell value={row.original.statistics.likeCount} />
    ),
    disableSortBy: true,
    width: 100,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Comments</Heading>} />
    ),
    id: 'comments',
    Cell: ({ row }: CellProps<SocialSharePodcasts>) => (
      <TableCells.NumericCell value={row.original.statistics.commentCount} />
    ),
    disableSortBy: true,
    width: 100,
  },
];

export default columns;
